import { render, staticRenderFns } from "./addGoodstype.vue?vue&type=template&id=6537f1d8&scoped=true&"
import script from "./addGoodstype.vue?vue&type=script&lang=ts&"
export * from "./addGoodstype.vue?vue&type=script&lang=ts&"
import style0 from "./addGoodstype.vue?vue&type=style&index=0&id=6537f1d8&lang=scss&scoped=true&"
import style1 from "./addGoodstype.vue?vue&type=style&index=1&id=6537f1d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6537f1d8",
  null
  
)

export default component.exports